export default {
  login: data => ({
    url: `/login`,
    method: 'POST',
    data
  }),
  logout: () => ({
    url: `/logout`,
    method: 'GET'
  }),
  getProfile: () => ({
    url: `/profile`,
    method: 'GET'
  }),
  changePassword: data => ({
    url: `/password`,
    method: 'PUT',
    data
  }),
  getProfileSites: () => ({
    url: '/profile/site',
    method: 'GET'
  }),
  getProfileSiteDevices: () => ({
    url: '/profile/site/device',
    method: 'GET'
  }),
  getOrgSiteDevices: () => ({
    url: 'profile/site/org',
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Profile.js